export default __webpack_public_path__ + "static/media/2.b04804e0.png";